class PricingCard {
	constructor(selector = ".pricing-card") {
		this.cards = [...document.querySelectorAll(selector)]

		if (!this.cards.length) {
			return
		}

		this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
		this.canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches

		this.init()
	}

	init() {
		this.reveal()
		this.bindRipple()

		if (!this.prefersReducedMotion && this.canHover) {
			this.bindTilt()
		}
	}

	reveal() {
		if (this.prefersReducedMotion || typeof IntersectionObserver === "undefined") {
			this.cards.forEach(card => card.classList.add("visible"))
			return
		}

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return
					}

					entry.target.classList.add("visible")
					observer.unobserve(entry.target)
				})
			},
			{
				rootMargin: "0px 0px -100px 0px",
				threshold: 0.25
			}
		)

		this.cards.forEach(card => observer.observe(card))
	}

	bindTilt() {
		this.cards.forEach(card => {
			card.addEventListener("mousemove", event => this.handleTilt(event, card))
			card.addEventListener("mouseleave", () => this.resetTilt(card))
		})
	}

	handleTilt(event, card) {
		const rect = card.getBoundingClientRect()
		const x = event.clientX - rect.left
		const y = event.clientY - rect.top
		const centerX = rect.width / 2
		const centerY = rect.height / 2
		const rotateY = ((x - centerX) / centerX) * 4
		const rotateX = ((centerY - y) / centerY) * 4

		card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px)`
	}

	resetTilt(card) {
		card.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0)"
	}

	bindRipple() {
		this.cards.forEach(card => {
			const button = card.querySelector(".pricing-button")

			if (button) {
				button.addEventListener("click", event => this.createRipple(event, button))
			}
		})
	}

	createRipple(event, button) {
		const circle = document.createElement("span")
		const diameter = Math.max(button.clientWidth, button.clientHeight)
		const rect = button.getBoundingClientRect()

		button.querySelectorAll(".pricing-ripple").forEach(ripple => ripple.remove())

		circle.className = "pricing-ripple"
		circle.style.width = `${diameter}px`
		circle.style.height = `${diameter}px`
		circle.style.left = `${event.clientX - rect.left - diameter / 2}px`
		circle.style.top = `${event.clientY - rect.top - diameter / 2}px`

		button.appendChild(circle)
	}
}

export default PricingCard